

export const virtualDJModes = [
    {
        key: 'VIRTUAL_DJ',
        label: 'Automated by Waved',
        description: 'Let Waved shuffle your playlists!'
    },
    {
        key: 'RECOMMEND_PLAYLISTS',
        label: 'Recommend by Waved',
        description: 'Get live playlist suggestions from Waved!'
    },
    {
        key: 'OFF',
        label: 'Manual',
        description: 'Oh well, figure it out yourself then...'
    }
];

export const virtualDjDataSources = [
    {
        key: 'VENUE_REPRESENTATIVE',
        label: 'Smart Selection',
        description: 'Uses AI to focus on the zones most relevant to the current situation.'
    },
    {
        key: 'BUSIEST',
        label: 'Busiest Zone',
        description: 'Focuses on your busiest zone - ideal for an upbeat vibe.'
    },
    {
        key: 'VENUE_AVERAGE',
        label: 'Venue Average',
        description: 'Considers all zones equally, suitable for small venues.'
    },
    {
        key: 'CUSTOM',
        label: 'Custom',
        description: 'Define a set of zones to analyze for music selection.'
    }
]

// Object of keys for easy access to mode keys
export const virtualDjModeKeys = virtualDJModes.reduce((acc, mode) => {
  acc[mode.key] = mode.key;
  return acc;
}, {});